
import Lottie from "lottie-react";
import loading from "./loading-animation.json"

export function Loading({ progress }: { progress: number }) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-white dark:bg-gray-900 z-50">
      <Lottie className="w-48 h-48" animationData={loading} loop={true} />
      <div className="mt-4 text-gray-600 dark:text-gray-300">
            Loading... {Math.round(progress * 100)}%
          </div>
      </div>
    );
  }